module.exports = __webpack_public_path__ + "static/r24-0ac8096b004901ae382fd44365b61337.jpg";